(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bridges-live-series"]) return;
  try {
    
  $(document).ready(function() {
    const tags = document.querySelectorAll('.tags');
    tags.forEach(function(tag) {
        // Trim any leading/trailing whitespace first
        const cleanText = tag.textContent.trim();

        // Now slice the cleaned text
        const truncatedText = cleanText.slice(0, -1);
        tag.textContent = truncatedText;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridges-series"]) return;
  try {
    
  $(document).ready(function() {
    const tags = document.querySelectorAll('.tags');
    tags.forEach(function(tag) {
        // Trim any leading/trailing whitespace first
        const cleanText = tag.textContent.trim();

        // Now slice the cleaned text
        const truncatedText = cleanText.slice(0, -1);
        tag.textContent = truncatedText;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outliers-series"]) return;
  try {
    
  $(document).ready(function() {
    const tags = document.querySelectorAll('.tags');
    tags.forEach(function(tag) {
        // Trim any leading/trailing whitespace first
        const cleanText = tag.textContent.trim();

        // Now slice the cleaned text
        const truncatedText = cleanText.slice(0, -1);
        tag.textContent = truncatedText;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharpen-your-skills-series"]) return;
  try {
    
  $(document).ready(function() {
    const tags = document.querySelectorAll('.tags');
    tags.forEach(function(tag) {
        // Trim any leading/trailing whitespace first
        const cleanText = tag.textContent.trim();

        // Now slice the cleaned text
        const truncatedText = cleanText.slice(0, -1);
        tag.textContent = truncatedText;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sponsor-slider"]) return;
  try {
    
  $('.logo-carousel').owlCarousel({
      items:1,
      lazyLoad:true,
      loop:true,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 2000,
      margin: 24,
      nav: false,
      dots: false,
      autoHeight: false,
      center: true,
      responsive: {
        0:{items:2, margin:0,},
        450:{items:2.5, margin:6,},
        600:{items:3.5, margin:12,},
        900:{items:4.25,},
        1200:{items:6, margin:24,},
        1400:{items:8, margin:18,},
        1900:{items:10,},
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tactics-series"]) return;
  try {
    
  $(document).ready(function() {
    const tags = document.querySelectorAll('.tags');
    tags.forEach(function(tag) {
        // Trim any leading/trailing whitespace first
        const cleanText = tag.textContent.trim();

        // Now slice the cleaned text
        const truncatedText = cleanText.slice(0, -1);
        tag.textContent = truncatedText;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taylor-reacts-series"]) return;
  try {
    
  $(document).ready(function() {
    const tags = document.querySelectorAll('.tags');
    tags.forEach(function(tag) {
        // Trim any leading/trailing whitespace first
        const cleanText = tag.textContent.trim();

        // Now slice the cleaned text
        const truncatedText = cleanText.slice(0, -1);
        tag.textContent = truncatedText;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upgrade-culture-series"]) return;
  try {
    
  $(document).ready(function() {
    const tags = document.querySelectorAll('.tags');
    tags.forEach(function(tag) {
        // Trim any leading/trailing whitespace first
        const cleanText = tag.textContent.trim();

        // Now slice the cleaned text
        const truncatedText = cleanText.slice(0, -1);
        tag.textContent = truncatedText;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
